import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import DropzoneComponent from 'react-dropzone-component'
import { graphql, compose, withApollo } from 'react-apollo'
import { AvForm, AvField } from 'availity-reactstrap-validation'
import { Button, CardHeader, CardBody, Col, Row, Label, Table, FormFeedback, Progress, Card } from 'reactstrap'
import { CertificateDictionariesQuery, createOrUpdateCertificatesMutation } from './mutations'
import CreatableSelect from '../Wps/CreatableSelect'
import { destroyAttachmentsMutation } from '../Projects/mutations'
import { UploadFiles, acceptedFiles, acceptedFilesIcons, updateAttachemntsInStore } from '../../utils/uploadFiles'
import CertificateRow from './helpers/CertificateRow'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'
import { FilesList } from '../Support'
import { onDestroySelect, destroyAttachments } from '../../utils/forms/removeFiles'
import { StandardForm } from './forms'
import { UnmountClosed } from 'react-collapse'
import DynamicInputs from '../Support/dynamicInputs/DynamicInputs'
import * as helpers from '../Support/dynamicInputs/helpers'

export const emptyDictionaries = {
  filler_material_groups: [],
  filler_materials: [],
  product_types: [],
  type_of_welds: [],
  weld_details: [],
  welding_positions: [],
  welding_processes: [],
  type_of_weldings: [],
  metal_transfers: [],
  material_groups: [],
  dimensions: [],
  qualification_data_types: [],
  revalidation_methods: [],
  type_of_current_polarities: [],
}

export const emptyDictionariesFieldsValues = {
  welding_process: [],
  product_type: [],
  type_of_weld: [],
  filler_material_group: [],
  filler_material: [],
  welding_position: [],
  weld_detail: [],
  type_of_welding: [],
  metal_transfer: [],
  material_group: [],
  dimensions: [],
  revalidation_method: [],
  type_of_current_polarity: [],
  data: [],
}

class CertificateForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      welder: {},
      validation_errors: {},
      validation_errors_msg: null,
      ...this.fillFormDataFromProps(props.editData),
      files: [],
      filesSelectedToRemove: [],
      submitFormProgress: null
    }

    this.onDestroySelect = onDestroySelect.bind(this)
    this.submitFunction = this.submitFunction.bind(this)
    this.handleSelectStandardValueChange = this.handleSelectStandardValueChange.bind(this)
    this.handleSelectValueChange = this.handleSelectValueChange.bind(this)

    this.djsConfig = {
      addRemoveLinks: true,
      autoProcessQueue: false,
      acceptedFiles: acceptedFiles,
      maxFiles: 1,
    }
    this.componentConfig = {
      iconFiletypes: acceptedFilesIcons,
      showFiletypeIcon: true,
      postUrl: 'no-url',
    }
    this.dropzone = null
  }

  static propTypes = {
    welderList: PropTypes.array.isRequired,
    standardsDictionary: PropTypes.array.isRequired,
    createOrUpdateCertificatesMutation: PropTypes.func.isRequired,
    formToggleFunction: PropTypes.func.isRequired,
    clearFunction: PropTypes.func.isRequired,
    client: PropTypes.object.isRequired,
    welder_id: PropTypes.number,
    editData: PropTypes.object
  }

  componentDidMount() {
    // withGaTracker(window.location.pathname + '/certificate_form') // GA TRACKER
  }

  componentWillUnmount() {
    this.props.clearFunction()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.editData !== this.props.editData) {
      this.setState(this.fillFormDataFromProps(nextProps.editData, nextProps.welder_id))
    }
  }

  fillFormDataFromProps(editData, welder_id = this.props.welder_id) {
    this.fillStandardData(editData)
    return {
      welder: this.props.welderList.find(o => Number(o.id) === welder_id) || {},
      dictionaries: emptyDictionaries,
      welding_process: editData.welding_processes || [],
      product_type: editData.product_types || [],
      type_of_weld: editData.type_of_welds || [],
      filler_material_group: editData.filler_material_groups || [],
      filler_material: editData.filler_materials || [],
      dimensions: helpers.convertObjectToArray(editData.dimensions),
      welding_position: editData.welding_positions || [],
      weld_detail: editData.weld_details || [],
      material_group: editData.material_groups || [],
      type_of_welding: editData.type_of_weldings || [],
      metal_transfer: editData.metal_transfers || [],
      revalidation_method: editData.revalidation_methods || [],
      type_of_current_polarity: editData.type_of_current_polarities || [],
      additional_info: editData.additional_info,
      data: helpers.convertObjectToArray(editData.data),
    }
  }

  fillStandardData(editData) {
    if (editData.standard) {
      let welding_processes_ids = editData.welding_processes.map(o => Number(o.id))
      let type_of_welds_ids = editData.type_of_welds.map(o => Number(o.id))
      let product_type_ids = editData.product_types.map(o => Number(o.id))
      // let material_group_ids = editData.material_groups.map(o => Number(o.id))
      // let revalidation_method_ids = editData.revalidation_methods.map(o => Number(o.id))
      // let type_of_current_polarity_ids = editData.type_of_current_polarities.map(o => Number(o.id))
      this.fetchDictionariesData(Number(editData.standard.id), welding_processes_ids,
        type_of_welds_ids, product_type_ids)
    } else {
      this.fetchDictionariesData(Number(this.props.standardsDictionary[1].id))
    }
  }

  fetchDictionariesData(standard_id, welding_process_ids = [], type_of_weld_ids = [], product_type_ids = []) {
    this.props.client.query({
      query: CertificateDictionariesQuery,
      fetchPolicy: 'network-only',
      variables: {
        standard_id: standard_id,
        welding_process_ids: welding_process_ids,
        type_of_weld_ids: type_of_weld_ids,
        product_type_ids: product_type_ids,
      }
    }).then(({ data }) => {
      let preparedData = {}
      Object.keys(emptyDictionaries).forEach(key => {
        preparedData[key] = data.welder_certificate_dictionaries[key].map(o => ({
          ...o,
          label: `${o.name}${o.description ? ' - ' + o.description : ''}`
        }))
      })
      preparedData.backing = data.welder_certificate_dictionaries.backing
      preparedData.vertical_progression = data.welder_certificate_dictionaries.vertical_progression
      preparedData.yes_no = data.welder_certificate_dictionaries.yes_no
      preparedData.type_of_run = data.welder_certificate_dictionaries.type_of_run
      this.setState({ dictionaries: preparedData, standard_id: standard_id })
    })
  }

  handleSelectStandardValueChange(value) {
    if (value && Number(value.id) !== this.state.standard_id) {
      this.fetchDictionariesData(Number(value.id))
      this.setState({ ...emptyDictionariesFieldsValues })
    } else {
      this.setState({ dictionaries: emptyDictionaries, standard_id: null, ...emptyDictionariesFieldsValues })
    }
  }

  handleSelectValueChange(inputName) {
    let self = this

    function updateSelectValue(values) {
      self.setState({ [inputName]: values }, () => {
        if (['welding_process', 'type_of_weld', 'product_type', 'material_group'].includes(inputName)) {
          self.fetchDictionariesData(self.state.standard_id,
            self.state.welding_process.map(o => Number(o.id)),
            self.state.type_of_weld.map(o => Number(o.id)),
            self.state.product_type.map(o => Number(o.id)),
          )
        }
      })

      if (inputName === 'welding_process' && (values === '' || self.state.welding_process.length > values.length)) {
        self.setState({ filler_material: [] })
      }
      if (inputName === 'type_of_weld' && (values === '' || self.state.type_of_weld.length > values.length)) {
        self.setState({ welding_position: [], weld_detail: [] })
      }
      if (['product_type', 'type_of_weld'].includes(inputName) && values) {
        let newDimensionValue = self.state.dimensions
        let currentDimensionKeys = self.state.dimensions.map(dimension => dimension.key)
        let valNames = values.map(o => o.name)
        if (!currentDimensionKeys.includes('s') && valNames.includes('BW')) {
          newDimensionValue.push({ key: 's', value: '' })
        }
        if (!currentDimensionKeys.includes('t') && valNames.includes('FW')) {
          newDimensionValue.push({ key: 't', value: '' })
        }
        if (!currentDimensionKeys.includes('s') && valNames.includes('T-joint')) {
          newDimensionValue.push({ key: 's', value: '' })
        }
        if (!currentDimensionKeys.includes('D') && valNames.includes('T')) {
          newDimensionValue.push({ key: 'D', value: '' })
        }
        self.setState({ dimensions: newDimensionValue })
      }
    }

    return updateSelectValue
  }

  submitFunction(e, values) {
    if (!this.state.welder.id || !this.state.standard_id) {
      return this.setState({ validation_errors_msg: [`Please select ${!this.state.welder.id ? 'Welder' : 'Standardization'}`] },
        () => { window.scrollTo(0, 0) })
    }

    this.props.createOrUpdateCertificatesMutation({
      variables: {
        welder_certificate: {
          id: this.props.editData ? this.props.editData.id : null,
          no: values.no,
          welder_id: Number(this.state.welder.id),
          standard_id: Number(this.state.standard_id),
          publisher: values.publisher,
          expiration_date: values.expiration_date,
          welding_process_ids: this.state.welding_process.map(o => Number(o.id)),
          product_type_ids: this.state.product_type.map(o => Number(o.id)),
          type_of_weld_ids: this.state.type_of_weld.map(o => Number(o.id)),
          filler_material_group_ids: this.state.filler_material_group.map(o => Number(o.id)),
          filler_material_ids: this.state.filler_material.map(o => Number(o.id)),
          dimensions: helpers.convertArrayToObject(this.state.dimensions, true),
          welding_position_ids: this.state.welding_position.map(o => Number(o.id)),
          weld_detail_ids: this.state.weld_detail.map(o => Number(o.id)),
          material_group_ids: this.state.material_group.map(o => Number(o.id) || null),
          type_of_welding_ids: this.state.type_of_welding.map(o => Number(o.id)),
          metal_transfer_ids: this.state.metal_transfer.map(o => Number(o.id)),
          revalidation_method_ids: this.state.revalidation_method.map(o => Number(o.id) || null),
          type_of_current_polarity_ids: this.state.type_of_current_polarity.map(o => Number(o.id) || null),
          data: helpers.convertArrayToObject(this.state.data),
          additional_info: values.additional_info
        }
      },
      refetchQueries: ({ data: { createOrUpdateCertificates } }) =>
        (!this.props.editData.id && !createOrUpdateCertificates.errors) ? ['WeldersListFetchQuery'] : []
    }).then(({ data: { createOrUpdateCertificates } }) => {
      if (createOrUpdateCertificates.errors) {
        // withGaEvent({category: 'Certificate', action: 'error save'}) // GA EVENT
        this.setState({
          validation_errors: JSON.parse(createOrUpdateCertificates.errors),
          validation_errors_msg: createOrUpdateCertificates.error_messages
        }, () => { window.scrollTo(0, 0) })
      } else {
        let certificate_id = createOrUpdateCertificates.certificate.id
        // withGaEvent({category: 'Certificate', action: 'save'}) // GA EVENT
        // REMOVE FILES
        destroyAttachments(this.props.client, this.state.filesSelectedToRemove, certificate_id, 'WlWelds::Qualification', 'Certificate')
        // ADD FILE
        if (this.state.files.length > 0) {
          UploadFiles(certificate_id, 'WlWelders::Qualification', this.state.files,
            { onUploadProgress: this.uploadProgress.bind(this) }).then((data) => {
              updateAttachemntsInStore(this.props.client, certificate_id, 'Certificate', { newAttachments: data })
            })
        }
        this.props.formToggleFunction()
      }
    })
  }

  uploadProgress(progressEvent) {
    let percentage = Math.round(progressEvent.loaded * 100.0 / progressEvent.total)
    this.setState({ submitFormProgress: percentage })
  }

  handleFileAdded(file) {
    this.setState({ files: [...this.state.files, file] })
  }

  handleFileRemoved(file) {
    let newFilesList = this.state.files.filter(function (item) {
      return (item !== file)
    })

    this.setState({ files: newFilesList })
  }

  render() {
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      addedfile: this.handleFileAdded.bind(this),
      removedfile: this.handleFileRemoved.bind(this)
    }

    return (
      <div>
        <CardHeader>{this.props.editData.id ? 'Edit Certificate' : 'Add new Certificate'}</CardHeader>
        <CardBody>
          {this.state.validation_errors_msg && <h4 className="errors-heading">{this.state.validation_errors_msg.join(', ')}</h4>}

          <AvForm id="certificate-form" onValidSubmit={this.submitFunction} className="FormClassLabel">
            <Row>
              <Col xs="12" sm="4">
                <CreatableSelect label="Welder" id="select-welder-certificate-form"
                  options={this.props.welderList}
                  valueKey="id"
                  disabled={!!this.props.welder_id}
                  value={this.state.welder}
                  multi={false}
                  creatable={false}
                  valueChangeFunction={this.handleSelectValueChange('welder')} />
                <FormFeedback>{this.state.validation_errors.welder}</FormFeedback>
              </Col>
              <Col xs="12" sm="4">
                <CreatableSelect label="Standardization" id="select-standard-certificate-form"
                  options={this.props.standardsDictionary}
                  valueKey="id"
                  value={this.state.standard_id}
                  multi={false}
                  creatable={false}
                  valueChangeFunction={this.handleSelectStandardValueChange} />
                <FormFeedback>{this.state.validation_errors.standard_id}</FormFeedback>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="4">
                <AvField
                  id="qualification-no-certificate-form"
                  name="no"
                  label="Certificate No"
                  type="text"
                  value={this.props.editData.no || ''}
                />
                <FormFeedback>{this.state.validation_errors.no}</FormFeedback>
              </Col>
              <Col xs="12" sm="4">
                <AvField
                  id="publisher-certificate-form"
                  name="publisher"
                  label="Publisher"
                  type="text"
                  value={this.props.editData.publisher || ''}
                />
                <FormFeedback>{this.state.validation_errors.publisher}</FormFeedback>
              </Col>
              <Col xs="12" sm="4">
                <AvField
                  id="expiration-date-certificate-form"
                  name="expiration_date"
                  label="Expiration date"
                  type="date"
                  value={this.props.editData.expiration_date || ''}
                />
                <FormFeedback>{this.state.validation_errors.expiration_date}</FormFeedback>
              </Col>
            </Row>

            <UnmountClosed isOpened={!!this.state.standard_id}>
              <StandardForm
                standard={this.props.standardsDictionary.find(o => Number(o.id) === this.state.standard_id)}
                values={_.pick(this.state, Object.keys(emptyDictionariesFieldsValues))}
                dictionaries={this.state.dictionaries}
                validationErrors={this.state.validation_errors}
                handleSelectChange={this.handleSelectValueChange}
              />
              {this.state.dictionaries.dimensions &&
                <DynamicInputs
                  label='Dimensions'
                  col={4}
                  valueArr={this.state.dimensions || []}
                  inputDict={this.state.dictionaries.dimensions}
                  dictValueKey='name'
                  validationErrors={this.state.validation_errors.dimensions}
                  handleChange={helpers.handleChangeDynamicInput('dimensions').bind(this)}
                  handleAdd={helpers.handleAddDynamicInput('dimensions').bind(this)}
                  handleDelete={helpers.handleDeleteDynamicInput('dimensions').bind(this)}
                  inputSettings='text'
                />}
              <hr />

              {this.state.dictionaries.qualification_data_types &&
                <DynamicInputs
                  valueArr={this.state.data || []}
                  inputDict={this.state.dictionaries.qualification_data_types}
                  validationErrors={this.state.validation_errors.data}
                  handleChange={helpers.handleChangeDynamicInput('data').bind(this)}
                  handleAdd={helpers.handleAddDynamicInput('data').bind(this)}
                  handleDelete={helpers.handleDeleteDynamicInput('data').bind(this)}
                  inputSettings={{
                    'Layers': { type: 'number' },
                    'Backing': { type: 'select', dict: this.state.dictionaries.backing },
                    'Inert backing': { type: 'select', dict: this.state.dictionaries.backing },
                    'Vertical progression': { type: 'select', dict: this.state.dictionaries.vertical_progression },

                    'Supplementary fillet weld': { type: 'select', dict: this.state.dictionaries.yes_no },
                    't': { type: 'number' },

                    'Job know': { type: 'select', dict: this.state.dictionaries.yes_no },
                    'Arc sensor control': { type: 'select', dict: this.state.dictionaries.yes_no },
                    'Automatic arc lenght control': { type: 'select', dict: this.state.dictionaries.yes_no },
                    'Automatic joint tracking': { type: 'select', dict: this.state.dictionaries.yes_no },
                    'Joint sensor': { type: 'select', dict: this.state.dictionaries.yes_no },
                    'Visual control': { type: 'select', dict: this.state.dictionaries.yes_no },
                    'Visual remote control': { type: 'select', dict: this.state.dictionaries.yes_no },
                    'Consumable insert': { type: 'select', dict: this.state.dictionaries.yes_no },
                    'Type of run': { type: 'select', dict: this.state.dictionaries.type_of_run },
                  }}
                />}
            </UnmountClosed>

            {!this.state.standard_id && <Card>
              <CardBody>
                <div className="text-center"><p className="empty-data"><b>Please select Standardization</b></p></div>
              </CardBody>
            </Card>}

            <Row>
              <Col xs="12" sm="12">
                <Label>Additional Info</Label>
                <AvField id="additional-info-welder-certificate-form"
                  name="additional_info"
                  type="textarea"
                  placeholder="type here additional information"
                  value={this.state.additional_info || ''}
                />
              </Col>
            </Row>
            <br />
            <DropzoneComponent config={this.componentConfig} eventHandlers={eventHandlers} djsConfig={this.djsConfig} />
            <br />
            <FilesList files={this.props.editData.attachments} onDestroySelect={this.onDestroySelect} />
            <br />
            {this.state.submitFormProgress &&
              <div>
                <div className="clearfix">
                  <div className="float-left">
                    <strong>Saving...</strong>
                  </div>
                </div>
                <Progress className="progress-xs" value={this.state.submitFormProgress} />
              </div>}

            <Button id="close-welder-form-btn" color="danger" className="float-right"
              onClick={this.props.formToggleFunction}>
              <i className="fa fa-close" /> Close
            </Button>
            <Button id="save-welder-form-btn" type="submit" color="primary" className="float-right">
              <i className="fa fa-plus" /> Save
            </Button>
            <br /> <br />
          </AvForm>

          <Row>
            <Col md="12">
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th scope="col" colSpan="14" style={{ textAlign: 'center' }}>Test designation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <CertificateRow welder_id={this.props.welder_id || 0}
                      dimensionsDictionary={this.state.dictionaries ? this.state.dictionaries.dimensions : []}
                      certificate={{
                        standard: this.props.standardsDictionary.find(o => Number(o.id) === this.state.standard_id) || { name: 'none' },
                        welding_processes: this.state.welding_process,
                        product_types: this.state.product_type,
                        type_of_welds: this.state.type_of_weld,
                        filler_material_groups: this.state.filler_material_group,
                        filler_materials: this.state.filler_material,
                        dimensions: helpers.convertArrayToObject(this.state.dimensions),
                        welding_positions: this.state.welding_position,
                        weld_details: this.state.weld_detail,
                        material_groups: this.state.material_group,
                        metal_transfers: this.state.metal_transfer,
                        type_of_weldings: this.state.type_of_welding,
                        revalidation_methods: this.state.revalidation_method,
                        type_of_current_polarities: this.state.type_of_current_polarity,
                      }}
                      noActions={true}
                    />
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </CardBody>
      </div>
    )
  }
}

const CertificateFormWithMutation = compose(
  graphql(createOrUpdateCertificatesMutation, { name: 'createOrUpdateCertificatesMutation' }),
  graphql(destroyAttachmentsMutation, { name: 'destroyAttachmentsMutation' }),
)(CertificateForm)

export default withApollo(CertificateFormWithMutation)



// WEBPACK FOOTER //
// ./src/components/Welders/CertificateForm.js